module.exports = __webpack_public_path__ + "static/media/6.8cf34d64.jpg";